import {
    Select,
    Layout,
    Table,
    message,
    Button,
    Upload,
    Spin,
    Image,
    DatePicker,
  } from "antd";
  import React, { useState, useEffect } from "react";
  import SideNavBar from "../../Components/SideBar/Sidebar";
  import Navbar from "../../Components/Support/Header";
  import { useHistory,Link } from "react-router-dom";
  import PRReportAbbott from "../PRReports/PRReportAbbott";
  import PRReportIntegra from "../PRReports/PRReportIntegra";
  import PRHPE from "../PRReports/PRReportHPE";
  import PRReportBMS from "../PRReports/PRReportBMS";
  import PRReports from "../PRReports/PRReportAmgen";
  import { downloadMultipleBMSmasterFileXL } from "../../Repository/PRReportsRepository";
  import axios from "axios";
  import moment from "moment";
  import Cookies from "js-cookie";
  // import "../PRReports/PRReports.css";
  import "../../GlobalCss/SPF/PRReports.css";
  import {
    DownloadOutlined,
    DeleteOutlined,
    LoadingOutlined,
  } from "@ant-design/icons";
  import {
    FormConfig,
    JsonConfig,
    StringConfig,
    UserName,
  } from "../../Repository/BaseRepository";
  import PRReportSales from "./PRReportSales";
  import PRReportTotalEnergies from "./PRReportTotalEnergies";
  import {
    downloadUnmatchedXL,
    downloadBMSUnmatchedXL,
    downloadAbbottUnmatchedXL,
    downloadIntegraUnmatchedXL,
    downloadHpeUnmatchedXL,
    downloadLeoforceUnmatchedXL,
    downloadAllUnmatchedXL,
  } from "../../Repository/PRReportsRepository";
  import * as XLSX from "xlsx";
  
  const { Header, Content } = Layout;
  
  const PRReportsMultiClients = () => {
    const [selectedClient, setSelectedClient] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
  
    const [loadingT, setLoadingTable] = useState(false);
    const [spinning, setSpinning] = useState(false);
    const [loader, setLoader] = useState(false);
  
    const [selectedMultiClients, setSelectedMultiClients] = useState([]);
    const history = useHistory();
    const [selectedClients, setSelectedClients] = useState([]);
    const [uploading, setUploading] = useState(false);
    const allowedClients = ["Abbott", "HPE", "Integra"];
    const BaseUrl = process.env.REACT_APP_BASE_URL;
    // Temp array to accumulate files
    const tempFiles = [];
  
    const [prreport, setPrreport] = useState([]);
    const [prUploader, setPrUploader] = useState("");
    const [activespin, setActivespin] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [Fromdate, setfromDate] = useState(null);
    const [ToDate, settoDate] = useState(null);
    const [loadingDate, setLoadingDate] = useState(false);
    const [LeoforceSelectedClient, setLeoforceSelectedCleints] = useState([]);
    const tenantName = Cookies.get("tenant_name")
    const disabledFutureDates = (current) => {
      // Disable future dates by ensuring date is not after today
      return current && current > moment().endOf("day");
    };
 
    // Fetch Leoforce Hrs Data
    const fetchLeoforceHrsData = async () => {
      const userLogin = Cookies.get("UserLogin");
    
      if (!LeoforceSelectedClient || LeoforceSelectedClient.length === 0) {
        message.error("Please select at least one client.");
        return;
      }
    
      try {
        const url = `${BaseUrl}PReports_/LeoforceHrsdata`;
    
        const requestBody = {
          client: "Leoforce",
          username: userLogin,
          Clientname: LeoforceSelectedClient,  // ✅ Ensure it's an array
        };
    
        console.log("Sending request to:", url);
        console.log("Request body:", requestBody);
    
        const response = await axios.post(url, requestBody, StringConfig);
    
        if (response.data.statusCode === 500) {
          message.error("There is no LeoforceHrs Data");
        } else {
          message.success(response.data.message);
        }
      } catch (error) {
        console.error("Error fetching LeoforceHrs data:", error.response?.data || error.message);
        message.error("Error fetching LeoforceHrs data");
      }
    };
    
    
  
    const handleFileUpload = async (options) => {
      const { file, onSuccess, onError } = options;
  
      // Ensure we are handling multiple files
      const validFiles = Array.isArray(file) ? file : [file]; // Handle single or multiple files
      const formData = new FormData();
  
      // Filter invalid files (files that don't match allowed client names)
      const invalidFiles = validFiles.filter((file) => {
        const fileName = file.name.split(".")[0];
        return !allowedClients.includes(fileName); // Check if the file name matches the allowed clients
      });
  
      // If any invalid file is found, show an error and return
      if (invalidFiles.length > 0) {
        message.error("Only files named Abbott, HPE, or Integra are allowed.");
        return;
      }
  
      // Prepare all valid files to be uploaded in one go
      validFiles.forEach((file) => {
        formData.append("inputFiles", file); // Append each file to the form data
      });
  
      // Construct the query parameters for all selected clients (e.g., clients=Abbott&clients=HPE)
      const clientParams = validFiles
        .map((file) => `clients=${encodeURIComponent(file.name.split(".")[0])}`)
        .join("&"); // Join multiple client parameters for all files
  
      // Show the active spinner
      setActivespin(true);
      setPrreport([]); // Clear the previous file report
      setPrUploader(validFiles.map(file => file.name).join(", ")); // Show all filenames being uploaded
  
      try {
        // Send all files in one API call
        const response = await axios.post(
          `${BaseUrl}PReports_/uploadDynamicInputFile?${clientParams}`, // Send query params for all clients
          formData,
          FormConfig
        );
  
        // Handle the response and update file statuses
        const updatedFiles = validFiles.map((file) => ({
          file,
          status: response.data.isSuccess ? "done" : "error",
        }));
  
        // Update the prreport with the latest file statuses
        setPrreport(updatedFiles);
        setPrUploader(""); // Reset uploader status
  
        // If the API call was successful, show a success message
        if (response.data.isSuccess) {
          message.success("Files uploaded successfully.");
          onSuccess(file); // Call onSuccess when upload is complete
        } else {
          message.error("Upload failed.");
          onError(file); // Call onError if upload failed
        }
      } catch (error) {
        console.error("Upload error:", error);
        message.error("Failed to upload file.");
        onError(file);
      } finally {
        setActivespin(false);
      }
    };
  
  
  
    const itemRender = (originNode, file) => {
      const statusColor = file.status === "done" ? "green" : "#f55451";
      const fileExists = prreport.length > 0;
  
      return (
        <div
          style={{
            display: "flex",
            height: "auto",
            width: 200,
            wordWrap: "break-word",
            marginTop: "9px",
          }}
        >
          <div
            style={{
              color: statusColor,
              height: "auto",
              display: "flex",
              wordWrap: "break-word",
              borderRadius: "4px",
            }}
          >
            {fileExists ? (
              <div
                style={{
                  height: "auto",
                  width: "fit-content",
                  wordBreak: "break-all",
                }}
              >
                {prreport.map((item) => item.file.name).join(", ")}
              </div>
            ) : null}
          </div>
          <DeleteOutlined
            style={{ marginLeft: 5 }}
            onClick={() => setPrreport([])}
          />
        </div>
      );
    };
  
  
    // Function to handle client selection
    const handleClientSelect = (value) => {
      setSelectedClients(value); // value is an array of selected clients
    };
 
  
    // Function to handle the download button click
    const handleDownloadClick = async () => {
      if (selectedClients.length > 0) {
        setSpinning(true);
        try {
          await downloadAllUnmatchedXL(selectedClients);
          // message.success("Download completed successfully!");
          setSelectedClients([]);
        } catch (error) {
          console.error("Download failed:", error);
          message.error("Download failed, please try again.");
        } finally {
          setSpinning(false);
        }
      } else {
        message.warning("Please select at least one client.");
      }
    };
    console.log("selected", selectedClients);
  
  
    // Multi-select client handler
    const handleMultiClientChange = (values) => {
      setSelectedMultiClients(values);
    };
    // Handle download for selected multiple clients
    const handleDownload = async () => {
      setLoader(true);
  
      try {
        // Create a list to hold all responses
        let allData = [];
        // Check if selected clients include any that require date validation
        // const requiresDateValidation = selectedMultiClients.some(
        //   (client) => client !== "PR_Amgen" && client !== "PR_BMS"
        // );
        if (Fromdate && ToDate) {
          if (!Fromdate || !ToDate) {
            message.error("Please select both From Date and To Date");
            return;
          }
  
          // Check if the dates are the same
          if (Fromdate.isSame(ToDate, "day")) {
            message.error("From Date and To Date cannot be the same");
            return;
          }
  
          // Check if From Date is after To Date
          if (Fromdate.isAfter(ToDate)) {
            message.error("From Date cannot be after To Date");
            return;
          }
        }
        const formattedfromDate = Fromdate ? Fromdate.format("MM-DD-YYYY") : null;
        const formattedtoDate = ToDate ? ToDate.format("MM-DD-YYYY") : null;
  
        // Helper function to fetch data for a specific client and merge it into allData
        const fetchDataForClient = async (client) => {
          let url;
          let response;
          let clientData = [];
  
          if (client === "PR_Amgen") {
            url = `${process.env.REACT_APP_BASE_URL}PReports_/Output_Data`;
            response = await axios.post(url, [client], JsonConfig);
            if (response.data.isSuccess) {
              clientData = JSON.parse(response.data.payload) || [];
            }
          } else if (client === "PR_BMS") {
            url = `${process.env.REACT_APP_BASE_URL}PReports_/PostingOutputData`;
            response = await axios.post(url, [client], JsonConfig);
            if (response.data.isSuccess) {
              clientData = JSON.parse(response.data.payload) || [];
            }
          } else {
            url = `${process.env.REACT_APP_BASE_URL}PReports_/DynamicMasterFile`;
            const queryParams = [];
            if (formattedfromDate) queryParams.push(`fromdate=${formattedfromDate}`);
            if (formattedtoDate) queryParams.push(`todate=${formattedtoDate}`);
  
            // Add query parameters to URL if available
            if (queryParams.length > 0) {
              url += `?${queryParams.join("&")}`;
            }
  
            response = await axios.post(url, [client], JsonConfig);
            if (response.data.isSuccess) {
              clientData = JSON.parse(response.data.payload) || [];
            }
          }
  
          // Exclude 'Id' from the data and merge it into allData
          clientData = clientData.map(({ Id, ...rest }) => rest);
          allData = allData.concat(clientData);
        };
  
        // Fetch data for each selected client
        await Promise.all(selectedMultiClients.map(fetchDataForClient));
  
        if (allData.length > 0) {
          // Convert allData to Excel and download
          const worksheet = XLSX.utils.json_to_sheet(allData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "ClientsData");
  
          // Trigger download
          XLSX.writeFile(workbook, "Masterfile.xlsx");
          message.success("Masterfile downloaded successfully.");
          setfromDate(null);
          settoDate(null);
  
        } else {
          message.info("No data available for the selected clients.");
        }
      } catch (error) {
        console.error("Error fetching data for download:", error);
        message.error("Failed to download data.");
      } finally {
        setLoader(false);
        setSelectedMultiClients([]);
      }
    };
  
  
  
    useEffect(() => {
      if (selectedClient) {
        fetchData(selectedClient);
      }
    }, [selectedClient]);
  
    const fetchData = async (client) => {
      setLoading(true);
      try {
        if (["leoforce"].includes(client)) {
          await handleSpecialClients(client);
        } else {
          const url = getClientUrl(client);
          await fetchClientData(url, client);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    const handleSpecialClients = async (client) => {
      try {
        const url = `${process.env.REACT_APP_BASE_URL}PReports_/GetClientsData`;
  
        const response = await axios.post(url, [client], JsonConfig);
        if (response.data.isSuccess) {
          setTableData(JSON.parse(response.data.payload) || []);
          // message.success(response.data.message);
        } else {
          message.info(
            response.data.message || "No data available for special client."
          );
        }
      } catch (error) {
        console.error("Error fetching special client data:", error);
      }
  
      const userLogin = Cookies.get("UserLogin");
  
      // First API call
      const params = { VMS: "Leoforce", frequency: "Weekly", userLogin };
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}Home/DownloadForSelectedClients`,
        ["Leoforce"],
        { ...JsonConfig, params }
      );
  
      // Second API call
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}PReports_/LeoforceHrsdata`,
        { params: { client, username: userLogin }, ...StringConfig }
      );
  
      if (response.data.statusCode === 500) {
        message.error("There is no LeoforceHrs Data");
      } else {
        message.success(response.data.message);
      }
  
    };
  
    const getClientUrl = (client) => {
      switch (client) {
        case "Abbott":
        case "Integra":
        case "HPE":
          return `${process.env.REACT_APP_BASE_URL}PReports_/GetClientsData`;
        case "PR_Amgen":
          return `${process.env.REACT_APP_BASE_URL}PReports_/getAmgenClientData`;
        case "PR_BMS":
          return `${process.env.REACT_APP_BASE_URL}PReports_/getBMSClientData`;
        default:
          return "";
      }
    };
  
    const fetchClientData = async (url, client) => {
      const response = await axios.post(url, [client], JsonConfig);
      if (response.data.isSuccess) {
        setTableData(JSON.parse(response.data.payload) || []);
        message.success(response.data.message);
        // console.log(response.data.message)
      } else {
        message.info(response.data.message || "No data available.");
        // console.log(response.data.message)
      }
    };

  
    return (
      <Layout
        style={{
          backgroundColor: "white",
          height: "100vh",
          display: "flex",
          overflow: "hidden",
        }}
      >
        <SideNavBar />
        <Layout className="whole-div">
          <Header className="timecards-header">
            <Navbar />
          </Header>
          <Content style={{ overflowY: "scroll", overflowX: "hidden" }}>
          <div className="payrollhrs-allpages-class">
          <Link to={`/${tenantName}/prreportshomepage`}><Button className="page-button">Single Client Process</Button></Link>
                        <Button className="payrollhrs-currentpage-button">Multi Clients Process</Button>
                      
                       
                    </div>
          
  
            <div style={{ display: "flex", justifyContent: "row", marginLeft: "2%",marginTop:"10%" }}>
              <Upload
                className="pr-upload-file"
                name="file"
                multiple
                customRequest={handleFileUpload}
                itemRender={itemRender}
                fileList={prreport}
                accept=".xls,.xlsx"
                onRemove={() => setPrreport([])}
                style={{
                  border: "1px solid #002766",
                  borderRadius: 10,
                  borderStyle: "dashed",
                  marginLeft: "70px",
  
                }}
                showUploadList={{ showPreviewIcon: false, showRemoveIcon: true }}
              >
                <span className="hrfile-name" style={{ padding: "8px" }}>
                  Upload InputFiles
                </span>
                {activespin ? (
                  <Spin
                    indicator={
                      <LoadingOutlined
                        className="upload-spinner"
                        style={{ fontSize: 16, marginLeft: 7 }}
                        spin
                      />
                    }
                  />
                ) : (
                  <Image
                    src="/Images/uploadimg.png"
                    style={{ border: "none", width: 19, height: 17 }}
                    showPreviewIcon={false}
                    preview={false}
                  />
                )}
              </Upload>
              <Select
                mode="multiple"
                size="large"
                maxTagCount="responsive"
                allowClear
                style={{ marginBottom: "20px", width: "17%", marginLeft: "10px" }}
                placeholder="UnmatchedList Download"
                onChange={handleClientSelect}
                value={selectedClients}
                options={[
                  // { value: "PR_Amgen", label: "PR_Amgen" },
                  // { value: "PR_BMS", label: "PR_BMS" },
  
                  { value: "Abbott", label: "Abbott" },
                  { value: "Integra", label: "Integra" },
                  { value: "HPE", label: "HPE" },
  
                  { value: "leoforce", label: "Leoforce" },
                ]}
              />
  
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                style={{ height: 39, marginLeft: "12px" }}
                onClick={handleDownloadClick}
                loading={spinning}
              ></Button>
              <Select
                mode="multiple"
                size="large"
                maxTagCount="responsive"
                allowClear
                value={selectedMultiClients}
                style={{ marginBottom: "20px", width: "12%", marginLeft: "50px" }}
                placeholder="Select clients "
                onChange={handleMultiClientChange}
                options={[
                  { value: "PR_Amgen", label: "PR_Amgen" },
                  { value: "PR_BMS", label: "PR_BMS" },
                  { value: "Abbott", label: "Abbott" },
                  { value: "Integra", label: "Integra" },
                  { value: "HPE", label: "HPE" },
                  { value: "leoforce", label: "Leoforce" },
                ]}
              />
              <DatePicker
                placeholder="Select From Date"
                value={Fromdate}
                onChange={(date) => setfromDate(date)}
                format="MM-DD-YYYY"
                style={{ marginRight: 20, height: "38px", marginLeft: "50px" }}
                disabledDate={disabledFutureDates} 
              />
              <DatePicker
                placeholder="Select To Date"
                value={ToDate}
                onChange={(date) => settoDate(date)}
                format="MM-DD-YYYY"
                style={{ marginRight: 20, height: "38px" }}
                disabledDate={disabledFutureDates} 
              />
              <Button
                type="primary"
                onClick={handleDownload}
                loading={loader}
                style={{ marginLeft: "10px", height: "38px" }}
                disabled={selectedMultiClients.length === 0}
              >
                Download All Masterfiles
              </Button>
            </div>
           
  
          </Content>
        </Layout>
      </Layout>
    );
  };
  
  export default PRReportsMultiClients;
  